<div class="instruction flex rounded-sm text-xs p-2">
  <i class="pi pi-info-circle text-sm"></i>
  <div class="pl-2">
    @if (summary) {
      <p
        class="instruction-summary font-semibold leading-relaxed"
        [class.mb-1]="detail"
      >
        {{ summary }}
      </p>
    }
    @if (detail) {
      <p class="instruction-detail leading-relaxed">
        {{ detail }}
      </p>
    }
  </div>
</div>
